<template>
  <div class="list-page-container">
    <!-- 顶部操作区 -->
    <div class="control-panel">
      <div class="control-container">
        <div class="header-info">
          <i class="el-icon-document"></i>
          <span>{{ $t('system.logManagementTips') }}</span>
        </div>
        <div class="header-actions">
          <el-button type="danger" size="small" plain icon="el-icon-delete" @click="handleTruncate" v-if="hasPermission('sys:log:delete')">{{ $t('system.clear') }}</el-button>
          <el-dropdown @command="handleExportCommand" v-if="hasPermission('sys:log:export')">
            <el-button type="success" size="small" plain icon="el-icon-download">
              {{ $t('system.export') }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="excel" icon="el-icon-document">Excel</el-dropdown-item>
              <el-dropdown-item command="csv" icon="el-icon-tickets">CSV</el-dropdown-item>
              <el-dropdown-item command="pdf" icon="el-icon-printer">PDF</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- 标签页切换 -->
    <el-tabs v-model="activeTab" class="custom-tabs" @tab-click="handleTabClick">
      <!-- 操作日志 -->
      <el-tab-pane :label="$t('system.operationLog')" name="operation">
        <div class="tab-content">
          <div class="sub-filter-row">
            <el-radio-group v-model="currentData.queryForm.targetType" size="small" @change="handleSubCategoryChange" class="custom-radio-group">
              <el-radio-button label="">{{ $t('common.all') }}</el-radio-button>
              <el-radio-button label="user">{{ $t('system.userOperationLog') }}</el-radio-button>
              <el-radio-button label="role">{{ $t('system.roleOperationLog') }}</el-radio-button>
              <el-radio-button label="device">{{ $t('system.deviceOperationLog') }}</el-radio-button>
              <el-radio-button label="agent">{{ $t('system.agentOperationLog') }}</el-radio-button>
            </el-radio-group>
          </div>
          
          <div class="control-panel has-query">
            <div class="filter-wrapper">
              <el-form :inline="true" :model="currentData.queryForm" class="filter-form">
                <el-form-item v-if="currentData.queryForm.targetType === 'user' || currentData.queryForm.targetType === ''" :label="$t('common.username')">
                  <el-input v-model="currentData.queryForm.username" :placeholder="$t('system.usernamePlaceholder')" clearable @change="handleSearch" class="filter-input"></el-input>
                </el-form-item>
                
                <el-form-item v-if="currentData.queryForm.targetType === 'role'" :label="$t('system.roleName')">
                  <el-input v-model="currentData.queryForm.targetId" :placeholder="$t('system.roleName')" clearable @change="handleSearch" class="filter-input"></el-input>
                </el-form-item>

                <el-form-item v-if="currentData.queryForm.targetType === 'device'" :label="$t('system.deviceId')">
                  <el-input v-model="currentData.queryForm.targetId" :placeholder="$t('system.deviceId')" clearable @change="handleSearch" class="filter-input"></el-input>
                </el-form-item>

                <el-form-item v-if="currentData.queryForm.targetType === 'agent'" :label="$t('system.agentId')">
                  <el-input v-model="currentData.queryForm.targetId" :placeholder="$t('system.agentId')" clearable @change="handleSearch" class="filter-input"></el-input>
                </el-form-item>

                <el-form-item :label="$t('common.dateRange')">
                  <el-date-picker
                    v-model="currentData.timeRange"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :range-separator="$t('system.to')"
                    :start-placeholder="$t('system.startTime')"
                    :end-placeholder="$t('system.endTime')"
                    @change="handleSearch"
                    class="filter-date-picker"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item class="search-btns">
                  <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                  <el-button icon="el-icon-refresh" @click="handleReset">{{ $t('common.reset') }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>

          <el-card class="list-card">
            <el-table v-loading="currentData.loading" :data="currentData.logList" style="width: 100%" height="100%" class="custom-table" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              
              <!-- 根据子类型展示不同列 -->
              <template v-if="currentData.queryForm.targetType === 'user' || currentData.queryForm.targetType === ''">
                <el-table-column prop="username" :label="$t('common.username')" width="120" align="center">
                  <template slot-scope="scope">
                    <span class="user-cell">{{ scope.row.username || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="targetId" :label="$t('system.targetId')" width="120" align="center">
                  <template slot-scope="scope">
                    <template v-if="scope.row.targetId">
                      <router-link v-if="scope.row.targetType === 'user'" :to="'/user/detail/' + scope.row.targetId" class="id-link">
                        {{ scope.row.targetId }}
                      </router-link>
                      <span v-else>{{ scope.row.targetId }}</span>
                    </template>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="action" :label="$t('system.operationContent')" min-width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="action-text">{{ getActionLabel(scope.row.action) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="ip" :label="$t('common.ip')" width="140" align="center"></el-table-column>
              </template>

              <template v-if="currentData.queryForm.targetType === 'role'">
                <el-table-column prop="targetId" :label="$t('system.roleName')" width="120" align="center"></el-table-column>
                <el-table-column prop="username" :label="$t('common.username')" width="120" align="center">
                  <template slot-scope="scope">
                    <span class="user-cell">{{ scope.row.username || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="action" :label="$t('system.permissionChange')" min-width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="action-text">{{ getActionLabel(scope.row.action) }}</span>
                  </template>
                </el-table-column>
              </template>

              <template v-if="currentData.queryForm.targetType === 'device'">
                <el-table-column prop="username" :label="$t('common.username')" width="120" align="center">
                  <template slot-scope="scope">
                    <span class="user-cell">{{ scope.row.username || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="targetId" :label="$t('system.deviceId')" width="150" align="center"></el-table-column>
                <el-table-column prop="action" :label="$t('system.operationContent')" min-width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="action-text">{{ getActionLabel(scope.row.action) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="status" :label="$t('system.operationStatus')" width="100" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.status ? 'success' : 'danger'" size="mini" effect="plain">
                      {{ scope.row.status ? $t('system.success') : $t('system.fail') }}
                    </el-tag>
                  </template>
                </el-table-column>
              </template>

              <template v-if="currentData.queryForm.targetType === 'agent'">
                <el-table-column prop="targetId" :label="$t('system.agentId')" width="150" align="center"></el-table-column>
                <el-table-column prop="action" :label="$t('system.operationContent')" min-width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="action-text">{{ getActionLabel(scope.row.action) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="status" :label="$t('system.operationStatus')" width="100" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.status ? 'success' : 'danger'" size="mini" effect="plain">
                      {{ scope.row.status ? $t('system.success') : $t('system.fail') }}
                    </el-tag>
                  </template>
                </el-table-column>
              </template>

              <el-table-column prop="type" :label="$t('system.logType')" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="getTypeTag(scope.row.type)" size="mini" effect="dark">
                    {{ getTypeLabel(scope.row.type) }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="createDate" :label="$t('system.operationTime')" width="170" align="center">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.createDate) }}
                </template>
              </el-table-column>
              
              <el-table-column v-if="hasAnyActionPermission" :label="$t('common.operation')" :width="operationActionWidth" align="center" fixed="right">
                <template slot-scope="scope">
                  <div class="action-buttons">
                    <el-button type="primary" size="mini" plain icon="el-icon-view" @click="handleViewDetail(scope.row)">{{ $t('common.detail') }}</el-button>
                    <el-button v-if="scope.row.targetType && scope.row.targetId" type="text" size="small" icon="el-icon-link" @click="handleGoTarget(scope.row)">{{ getTargetActionLabel(scope.row.targetType) }}</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-card>

          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentData.queryForm.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="currentData.queryForm.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="currentData.total"
            ></el-pagination>
          </div>
        </div>
      </el-tab-pane>

      <!-- 错误日志 -->
      <el-tab-pane :label="$t('system.errorLog')" name="error">
        <div class="tab-content">
          <div class="control-panel has-query">
            <div class="filter-wrapper">
              <el-form :inline="true" :model="currentData.queryForm" class="filter-form">
                <el-form-item :label="$t('common.dateRange')">
                  <el-date-picker
                    v-model="currentData.timeRange"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :range-separator="$t('system.to')"
                    :start-placeholder="$t('system.startTime')"
                    :end-placeholder="$t('system.endTime')"
                    @change="handleSearch"
                    class="filter-date-picker"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item class="search-btns">
                  <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                  <el-button icon="el-icon-refresh" @click="handleReset">{{ $t('common.reset') }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <el-card class="list-card">
            <el-table v-loading="currentData.loading" :data="currentData.logList" style="width: 100%" height="100%" class="custom-table">
              <el-table-column prop="action" :label="$t('system.action')" min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="action-text error">{{ getActionLabel(scope.row.action) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="detail" :label="$t('system.detail')" min-width="300" show-overflow-tooltip></el-table-column>
              <el-table-column prop="createDate" :label="$t('system.operationTime')" width="170" align="center">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.createDate) }}
                </template>
              </el-table-column>
              <el-table-column v-if="hasAnyActionPermission" :label="$t('common.operation')" :width="errorActionWidth" align="center" fixed="right">
                <template slot-scope="scope">
                  <div class="action-buttons">
                    <el-button type="primary" size="mini" plain icon="el-icon-view" @click="handleViewDetail(scope.row)">{{ $t('common.detail') }}</el-button>
                    <el-button type="warning" size="mini" plain icon="el-icon-document-copy" @click="handleCopyError(scope.row)">{{ $t('system.copyError') }}</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-card>

          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentData.queryForm.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="currentData.queryForm.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="currentData.total"
            ></el-pagination>
          </div>
        </div>
      </el-tab-pane>

      <!-- 系统日志 -->
      <el-tab-pane :label="$t('system.systemLog')" name="system">
        <div class="tab-content">
          <div class="control-panel has-query">
            <div class="filter-wrapper">
              <el-form :inline="true" :model="currentData.queryForm" class="filter-form">
                <el-form-item :label="$t('common.dateRange')">
                  <el-date-picker
                    v-model="currentData.timeRange"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :range-separator="$t('system.to')"
                    :start-placeholder="$t('system.startTime')"
                    :end-placeholder="$t('system.endTime')"
                    @change="handleSearch"
                    class="filter-date-picker"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item class="search-btns">
                  <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                  <el-button icon="el-icon-refresh" @click="handleReset">{{ $t('common.reset') }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <el-card class="list-card">
            <el-table v-loading="currentData.loading" :data="currentData.logList" style="width: 100%" height="100%" class="custom-table">
              <el-table-column prop="action" :label="$t('system.action')" min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="action-text system">{{ getActionLabel(scope.row.action) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="detail" :label="$t('system.detail')" min-width="300" show-overflow-tooltip></el-table-column>
              <el-table-column prop="createDate" :label="$t('system.operationTime')" width="170" align="center">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.createDate) }}
                </template>
              </el-table-column>
              <el-table-column v-if="hasAnyActionPermission" :label="$t('common.operation')" width="100" align="center" fixed="right">
                <template slot-scope="scope">
                  <div class="action-buttons">
                    <el-button type="primary" size="mini" plain icon="el-icon-view" @click="handleViewDetail(scope.row)">{{ $t('common.detail') }}</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-card>

          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentData.queryForm.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="currentData.queryForm.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="currentData.total"
            ></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 详情对话框 - 操作日志 -->
    <el-dialog v-if="activeTab === 'operation'" :title="$t('system.logDetail')" :visible.sync="detailVisible" width="600px" custom-class="custom-dialog">
      <el-descriptions :column="1" border size="medium">
        <el-descriptions-item label="ID">{{ currentLog.id }}</el-descriptions-item>
        <el-descriptions-item :label="$t('system.logType')">
          <el-tag :type="getTypeTag(currentLog.type)" size="mini" effect="dark">
            {{ getTypeLabel(currentLog.type) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item v-if="currentLog.username" :label="$t('common.username')">
          <span class="user-cell">{{ currentLog.username }}</span>
        </el-descriptions-item>
        <el-descriptions-item v-if="currentLog.targetType" :label="$t('system.targetType')">
          <el-tag :type="getTargetTypeTag(currentLog.targetType)" size="mini" effect="plain">
            {{ getTargetTypeLabel(currentLog.targetType) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item v-if="currentLog.targetId" :label="$t('system.targetId')">
          <code class="id-code">{{ currentLog.targetId }}</code>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('system.action')">
          <span class="action-text-detail">{{ getActionLabel(currentLog.action) }}</span>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('common.ip')">{{ currentLog.ip || '-' }}</el-descriptions-item>
        <el-descriptions-item :label="$t('system.operationTime')">{{ formatDate(currentLog.createDate) }}</el-descriptions-item>
        <el-descriptions-item :label="$t('system.userAgent')">{{ currentLog.userAgent || '-' }}</el-descriptions-item>
        <el-descriptions-item :label="$t('system.detail')">
          <div class="json-content">
            <pre>{{ currentLog.detail || '-' }}</pre>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="detailVisible = false">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>

    <!-- 详情对话框 - 错误日志 -->
    <el-dialog v-if="activeTab === 'error'" :title="$t('system.logDetail')" :visible.sync="detailVisible" width="700px" custom-class="custom-dialog">
      <el-descriptions :column="1" border size="medium">
        <el-descriptions-item label="ID">{{ currentLog.id }}</el-descriptions-item>
        <el-descriptions-item :label="$t('system.logType')">
          <el-tag type="danger" size="mini" effect="dark">{{ $t('system.errorLog') }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('system.action')">
          <span class="action-text-detail error">{{ getActionLabel(currentLog.action) }}</span>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('system.operationTime')">{{ formatDate(currentLog.createDate) }}</el-descriptions-item>
        <el-descriptions-item :label="$t('system.errorDetail')">
          <div class="json-content error-content">
            <pre>{{ currentLog.detail || '-' }}</pre>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button type="warning" icon="el-icon-document-copy" @click="handleCopyError(currentLog)">{{ $t('system.copyError') }}</el-button>
        <el-button @click="detailVisible = false">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>

    <!-- 详情对话框 - 系统日志 -->
    <el-dialog v-if="activeTab === 'system'" :title="$t('system.logDetail')" :visible.sync="detailVisible" width="600px" custom-class="custom-dialog">
      <el-descriptions :column="1" border size="medium">
        <el-descriptions-item label="ID">{{ currentLog.id }}</el-descriptions-item>
        <el-descriptions-item :label="$t('system.logType')">
          <el-tag type="warning" size="mini" effect="dark">{{ $t('system.systemLog') }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('system.action')">
          <span class="action-text-detail system">{{ getActionLabel(currentLog.action) }}</span>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('system.operationTime')">{{ formatDate(currentLog.createDate) }}</el-descriptions-item>
        <el-descriptions-item :label="$t('system.detail')">
          <div class="json-content">
            <pre>{{ currentLog.detail || '-' }}</pre>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="detailVisible = false">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import logApi from '@/apis/system/log'
import { formatDate } from '@/utils/date'
import { hasPermission } from '@/utils/permission'

function createTabState(tabName) {
  return {
    loading: false,
    logList: [],
    total: 0,
    timeRange: [],
    queryForm: {
      page: 1,
      limit: 20,
      type: tabName,
      targetType: '',
      targetId: '',
      username: '',
      ip: '',
      startTime: '',
      endTime: ''
    },
    loaded: false
  }
}

export default {
  name: 'logManagementTips',
  data() {
    return {
      activeTab: 'operation',
      selectedLogs: [],
      detailVisible: false,
      currentLog: {},
      // 每个 Tab 维护独立的数据状态
      tabData: {
        operation: createTabState('operation'),
        error: createTabState('error'),
        system: createTabState('system')
      }
    }
  },
  computed: {
    currentData() {
      return this.tabData[this.activeTab]
    },
    hasAnyActionPermission() {
      return true
    },
    operationActionWidth() {
      return 180
    },
    errorActionWidth() {
      return 180
    }
  },
  mounted() {
    this.getLogList()
  },
  methods: {
    hasPermission,
    formatDate,

    async getLogList() {
      const data = this.currentData
      data.loading = true
      try {
        const params = { ...data.queryForm }
        if (data.timeRange && data.timeRange.length === 2) {
          params.startTime = data.timeRange[0]
          params.endTime = data.timeRange[1]
        }
        const res = await logApi.getLogPage(params)
        // 原子更新：同一次 tick 内同时设置列表数据和总数，避免中间状态导致分页组件闪烁
        data.logList = res.list
        data.total = res.total
        data.loaded = true
      } catch (e) {
        this.$message.error(this.$t('system.getLogsFailed'))
      } finally {
        data.loading = false
      }
    },

    handleSearch() {
      this.currentData.queryForm.page = 1
      this.getLogList()
    },

    handleReset() {
      const tab = this.activeTab
      this.currentData.queryForm = {
        page: 1,
        limit: this.currentData.queryForm.limit,
        type: tab,
        targetType: '',
        targetId: '',
        username: '',
        ip: '',
        startTime: '',
        endTime: ''
      }
      this.currentData.timeRange = []
      this.handleSearch()
    },

    handleTabClick(tab) {
      this.activeTab = tab.name
      // 仅在首次切换到该Tab时加载数据，避免重复请求
      if (!this.currentData.loaded) {
        this.getLogList()
      }
    },

    handleSubCategoryChange() {
      this.currentData.queryForm.targetId = ''
      this.currentData.queryForm.username = ''
      this.handleSearch()
    },

    handleSizeChange(val) {
      this.currentData.queryForm.limit = val
      this.currentData.queryForm.page = 1
      this.getLogList()
    },

    handleCurrentChange(val) {
      this.currentData.queryForm.page = val
      this.getLogList()
    },

    handleSelectionChange(val) {
      this.selectedLogs = val
    },

    handleViewDetail(row) {
      this.currentLog = row
      this.detailVisible = true
    },

    // 操作日志：跳转到关联对象
    handleGoTarget(row) {
      const routeMap = {
        user: `/user/detail/${row.targetId}`,
        device: `/device/detail/${row.targetId}`,
        agent: `/agent/detail/${row.targetId}`,
        role: `/role/detail/${row.targetId}`
      }
      const path = routeMap[row.targetType]
      if (path) {
        this.$router.push(path).catch(() => {})
      }
    },

    // 获取关联对象的操作按钮文字
    getTargetActionLabel(targetType) {
      const map = {
        user: this.$t('system.viewUser'),
        device: this.$t('system.viewDevice'),
        agent: this.$t('system.viewAgent'),
        role: this.$t('system.viewRole')
      }
      return map[targetType] || this.$t('common.detail')
    },

    // 错误日志：复制错误信息
    handleCopyError(row) {
      const errorText = [
        `Action: ${this.getActionLabel(row.action)}`,
        `Time: ${this.formatDate(row.createDate)}`,
        `Detail: ${row.detail || ''}`
      ].join('\n')

      navigator.clipboard.writeText(errorText).then(() => {
        this.$message.success(this.$t('system.copySuccess'))
      }).catch(() => {
        // 降级方案
        const textarea = document.createElement('textarea')
        textarea.value = errorText
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success(this.$t('system.copySuccess'))
      })
    },

    getTypeLabel(type) {
      if (!type) return '-'
      const key = `system.logEnums.type.${type}`
      return this.$te(key) ? this.$t(key) : type
    },

    getTypeTag(type) {
      const map = {
        operation: 'primary',
        error: 'danger',
        system: 'warning',
        login: 'success'
      }
      return map[type] || 'info'
    },

    getTargetTypeLabel(targetType) {
      if (!targetType) return '-'
      const key = `system.logEnums.targetType.${targetType}`
      return this.$te(key) ? this.$t(key) : targetType
    },

    getTargetTypeTag(targetType) {
      const map = {
        user: 'primary',
        role: 'warning',
        device: 'success',
        agent: 'info',
        job: 'danger'
      }
      return map[targetType] || ''
    },

    getActionLabel(action) {
      if (!action) return '-'
      const key = `system.logEnums.action.${action}`
      return this.$te(key) ? this.$t(key) : action
    },

    handleExportCommand(command) {
      this.handleExport(command)
    },

    async handleExport(format) {
      try {
        const data = this.currentData
        const params = { ...data.queryForm, format }
        if (data.timeRange && data.timeRange.length === 2) {
          params.startTime = data.timeRange[0]
          params.endTime = data.timeRange[1]
        }
        
        this.$message.info(this.$t('common.exporting'))
        const res = await logApi.exportLogs(params)
        
        const blob = new Blob([res], { 
          type: format === 'csv' ? 'text/csv' : (format === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') 
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        let extension = format
        if (format === 'excel') extension = 'xlsx'
        link.download = `logs_${this.activeTab}_${new Date().getTime()}.${extension}`
        link.click()
        window.URL.revokeObjectURL(url)
        this.$message.success(this.$t('system.exportSuccess'))
      } catch (e) {
        this.$message.error(this.$t('system.exportFailed'))
      }
    },

    async handleTruncate() {
      try {
        await this.$confirm(this.$t('system.confirmClearLogs'), this.$t('common.warning'), { type: 'warning' })
        await logApi.truncateLogs()
        this.$message.success(this.$t('system.clearSuccess'))
        // 重置所有Tab的加载状态并重新加载当前Tab
        Object.keys(this.tabData).forEach(key => {
          this.tabData[key].loaded = false
        })
        this.getLogList()
      } catch (e) {}
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/list-page.scss";

/* 日志管理页面特有样式 */
.list-page-container {
  .header-actions {
    display: flex;
    gap: 12px;
    .el-button { border-radius: 8px; font-weight: 500; }
  }

  .filter-form {
    .el-form-item { margin-bottom: 0; margin-right: 0; }
  }

  .filter-input { width: 180px; }
  .filter-date-picker { width: 320px !important; }

  .custom-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 10px;

    :deep(.el-tabs__header) {
      margin-bottom: 15px;
      border-bottom: 2px solid #f1f5f9;
      .el-tabs__nav-wrap::after { display: none; }
      .el-tabs__item {
        font-size: 15px;
        font-weight: 500;
        color: #64748b;
        height: 45px;
        line-height: 45px;
        &.is-active { color: #409eff; font-weight: 600; }
      }
      .el-tabs__active-bar { height: 3px; border-radius: 3px; }
    }

    :deep(.el-tabs__content) {
      flex: 1;
      overflow: hidden;
      .el-tab-pane { height: 100%; display: flex; flex-direction: column; }
    }

    .tab-content { height: 100%; display: flex; flex-direction: column; }
  }

  .sub-filter-row { padding: 0 0 15px 0; }

  .json-content {
    background: #f8fafc;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    pre { margin: 0; white-space: pre-wrap; font-family: monospace; font-size: 12px; color: #475569; }
  }

  .error-content {
    background: #fef2f2;
    border-color: #fecaca;
    pre { color: #991b1b; }
  }

  .user-cell {
    font-weight: 500;
    color: #1e293b;
  }

  .id-link {
    color: #3b82f6;
    text-decoration: none;
    font-weight: 500;
    &:hover {
      text-decoration: underline;
    }
  }

  .action-text {
    color: #475569;
    font-size: 13px;

    &.error { color: #ef4444; font-weight: 500; }
    &.system { color: #f59e0b; font-weight: 500; }
  }

  .action-text-detail {
    font-weight: 600;
    color: #0f172a;

    &.error { color: #ef4444; }
    &.system { color: #f59e0b; }
  }

  .id-code {
    background: #f1f5f9;
    padding: 2px 6px;
    border-radius: 4px;
    font-family: monospace;
    color: #64748b;
    font-size: 12px;
  }

  .action-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
}

@media screen and (max-width: 1440px) {
  .list-page-container .filter-input {
    width: 160px;
  }
  .list-page-container .filter-date-picker {
    width: 300px !important;
  }
}

@media screen and (max-width: 1024px) {
  .list-page-container .filter-input {
    width: 140px;
  }
  .list-page-container .filter-date-picker {
    width: 350px !important;
  }
}

@media screen and (max-width: 768px) {
  .list-page-container {
    padding: 0 5px 5px;

    .header-actions {
      .el-button {
        padding: 8px 12px;
        span { display: none; }
        i { margin: 0; font-size: 16px; }
      }
    }

    .control-panel.has-query {
      padding: 12px;
    }

    .filter-input, .filter-date-picker {
      width: 100% !important;
    }

    .search-btns {
      width: 100%;
      .el-button {
        flex: 1;
      }
    }
  }
}

@media screen and (max-width: 375px) {
  .list-page-container .header-actions {
    width: 100%;
    justify-content: space-between;
    .el-button {
      flex: 1;
    }
  }
}
</style>
